import Toast from 'react-bootstrap/Toast';
import { StyledToast, StyledToastsContainer } from './Toasts.styles';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { removeToast, setToasts } from './redux/actions';

const Toasts = () => {
  const toasts = useSelector(state => state.toasts.toasts);
  const dispatch = useDispatch();

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (toasts.length > 0) {
        const currentTime = Date.now();
        const updatedToasts = toasts.filter((toast) => currentTime - toast.time <= 5000);
        const removedToasts = toasts.filter((toast) => currentTime - toast.time > 5000);
        removedToasts.forEach((toast) => {
          dispatch(removeToast(toast.id));
        });
        dispatch(setToasts(updatedToasts));
      }
    }, 500);

    return () => clearInterval(intervalId);
  }, [toasts, dispatch]);

  const deleteToast = (id) => {
    dispatch(removeToast(id))
  }
  return (
    <StyledToastsContainer>
      {
        toasts.map((toast) => {
          return (
            <StyledToast status={toast.status} onClick={() => deleteToast(toast.id)}>
              <Toast.Header>
                <strong className="me-auto">{toast.header}</strong>
              </Toast.Header>
              <Toast.Body>{toast.body}</Toast.Body>
            </StyledToast>
          )
        })
      }
    </StyledToastsContainer>
  );
}

export default Toasts;